import { type Enum } from '@webapp/infrastructure/types/Enum'
import { type GlobalSearchResultTypeEnum } from '../../value-objects/enums'
import { type GlobalSearchResultApiModel } from '../api-models/GlobalSearchResultApiModel'

export type GlobalSearchStateMessage = { title: string; description: string }

export const GlobalSearchWarningCodes = {
  TRUNCATED_RESULTS: 'TRUNCATED_RESULTS',
  UNSUPPORTED_QUERY: 'UNSUPPORTED_QUERY',
  NO_RESULTS: 'NO_RESULTS',
} as const

type GlobalSearchWarningCode = Enum<typeof GlobalSearchWarningCodes>

type GlobalSearchWarning = {
  code: GlobalSearchWarningCode
  message?: Nullable<GlobalSearchStateMessage>
}

export const GlobalSearchIntents = {
  PRODUCT_PURCHASE: 'product_purchase',
  AMBIGUOUS: 'ambiguous',
} as const

type GlobalSearchIntent = Enum<typeof GlobalSearchIntents>

export type GlobalSearchApiMetadata = {
  total: number
  counts: { type: GlobalSearchResultTypeEnum; count: number }[]
  warnings?: GlobalSearchWarning[]
  intent?: Nullable<GlobalSearchIntent>
  original_query?: Nullable<string>
  envelope?: Nullable<GlobalSearchEnvelope>
}

export const GlobalSearchEnvelopeComponentTypes = {
  CONFIRMATION_BANNER: 'confirmation_banner',
} as const

type GlobalSearchEnvelopeComponentType = Enum<
  typeof GlobalSearchEnvelopeComponentTypes
>

export type GlobalSearchEnvelope = {
  id: string
  components: { type: GlobalSearchEnvelopeComponentType }[]
}

export type GlobalSearchResponsePayload = {
  data: GlobalSearchResultApiModel[]
  metadata?: GlobalSearchApiMetadata
  conversation_id?: Nullable<string>
}
